import { QueryKey } from '@tanstack/react-query';

const baseKey: QueryKey = ['authentication'] as const;

export const authenticationQueryKeys = {
  base: baseKey,
  createCheckout: [...baseKey, 'createCheckout'],
  getSubcriptionProducts: [...baseKey, 'getSubcriptionProducts'],
} as const;
